/* eslint-disable import/prefer-default-export */
import wrap from './wrap-root-element';

export const wrapRootElement = wrap;
